<template>
  <div class="modal fade" tabindex="-1" :id="id">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ $t('chat.shareMessage') }}
          </h5>
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click.prevent="closeModal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <Select2
                  :parent-id="'#'+id"
                  containerClass="col-12 mt-auto mb-5"
                  :name="`${id}-add-conversation`"
                  type="text"
                  :label="$t('chat.select_conversations')"
                  labelClass="form-label fs-6 text-black"
                  selectClass="form-select form-select-solid"
                  :isRequired="false"
                  size="lg"
                  v-model="formData.conversation_ids"
                  :multiple="true">
                <option v-for="conversation in conversations" :value="conversation.id">{{ getDiscussionName(conversation) }}</option>
              </Select2>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click.prevent="closeModal"/>
          <Button :isDisabled="!formData.conversation_ids.length" btn-class="btn-sm me-3" type="submit" btn-text="button.save" size="7px 30px" :is-loading="processing" @click.prevent="shareMessages" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import Select2 from "@/components/Select2.vue";
import Button from "@/components/Button.vue";
import {computed, ref} from "vue";
import {useStore} from "vuex";

const store = useStore()

const emits = defineEmits(['closeModal'])
const props = defineProps({
  id: { type: String, required: true},
  message: { type: Object, required: true }
})

const processing = ref(false)

const formData = ref({
  conversation_ids: []
})

const conversations = computed(() => store.getters['chat/getConversations'])

const getDiscussionName = (discussion) => {
  if(discussion.is_group) {
    return discussion.name
  } else {
    return discussion.peer?.name
  }
}

function closeModal(){
  $('#'+props.id).modal('toggle')
  emits('closeModal')
}

function shareMessages() {
  processing.value = true
  store.dispatch('chat/shareMessage', {
    conversation_ids: formData.value.conversation_ids,
    messages: [
      { id: props.message.id, type: props.message.type }
    ]
  })
      .then(() => {
        window.toastr['success'](i18n.global.t("chat.notification.message_shared"))
        closeModal()
      })
      .finally(() => processing.value = false)
}

</script>

<style scoped>

</style>